import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { UsgService } from '../gastro.service';
import { PathologyService } from '../pathology.service';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import { ExamsService } from '../exams.service';
import { PatientsService } from '../patients.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-labresults',
    templateUrl: './labresults.component.html',
    styleUrls: ['./labresults.component.scss'],
    standalone: false
})
export class LabresultsComponent implements OnInit {
  showInventorySearch: boolean = false;
  invStartdate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  invEnddate: Date = new Date();
  searchedInventories: any[] = [];

  status: string = 'Needs_payer';
  lab = '';
  startdate: Date  = new Date(new Date().setMonth(new Date().getMonth() - 1));
  enddate: Date = new Date();
  doctor: number = null;
  labResults: any[];
  reportToShow: number;
  messengerReportID: number = null;
  pdfMessengerID: number = null;
  activeInventories: any[];
  completedInventories: any[];
  inventorySigned = false;
  pdf:any = null;
  mode: string = 'results'; // 'results' | 'reports'

  constructor(
    public loginService: LoginService,
    private gastroService: UsgService,
    private sanitizer: DomSanitizer,
    private exServ: ExamsService,
    private pathologyService: PathologyService,
    private patientsService: PatientsService,
    private rt: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loginService.loginMissing();
    if(this.loginService.userType == 'doctor')
      this.doctor = this.loginService.UID;

    this.route.queryParams.subscribe(params => {
      const unassignedLabReports = Number(params['unassignedLabReports'] || 0);
      if (unassignedLabReports > 0) {
        this.status = 'Needs_Assignment';
      } else {
        switch(this.loginService.userType){
          case 'nurse':
            this.status = 'Awaiting_transfer';
            break;
          case 'doctor':
            this.status = 'Needs_Analysis';
            break;
          default:
            this.status = 'Needs_Assignment';
        }
      }
      this.getLabResults();
      if(this.loginService.userType != 'doctor')
        this.getActiveInventories();
    });
  }

  searchInventorySheets() {
    this.pathologyService.getCompletedInventories(this.invStartdate, this.invEnddate).subscribe((data: any[]) => {
      this.searchedInventories = data;
    });
  }

  getLabResults(){
    if(this.status  == 'Messenger_reports')
      return;
    if(this.status == 'Old_reports'){
      this.getInventoryHistory();
      return;
    }
    this.labResults = [];
    if(! this.status || (! this.lab && this.status == 'Awaiting_transfer'))
      return;
    this.gastroService.labResults(this.status, this.lab, this.doctor).subscribe((data:any[])=>{
      this.labResults = data;
      if(this.status == 'All' && data.length > 0  ){
        if(! data[0].PathologyID)
          this.status = "Needs_Assignment"; 
        else  
          if(! data[0].Analyzed)
            this.status = "Needs_Analysis";   
      }
    }, error => {
      console.error('Error fetching lab results:', error);
    });
  }

  goExam(examid,pid) {
    this.exServ.goExamNoPrelaod(examid,pid, this.status == 'Needs_payer');
  }

  makeMessengerReport(){
    let selected = []
    for (let result of this.labResults) {
      if (result.selected) {
        for(let pathology of result.pathology){
          selected.push(pathology.AutoIndex);
        }
      } 
    }
    if (selected.length > 0) {
        this.pathologyService.makeMessengerReport(selected, this.lab).subscribe((data) => {
          this.inventorySigned = false;
          this.messengerReportID = data['reportId'];
        });
      }
  }

  getActiveInventories(){
    this.pathologyService.getActiveInventories().subscribe((data:any[]) => {
      this.activeInventories = data;
      if( this.activeInventories && this.activeInventories.length > 0){
        if(this.loginService.userType == 'secretary')
          this.status = 'Messenger_reports';
        if(this.loginService.userType == 'nurse'){
          for(let inv of this.activeInventories){
            if(!inv.SigningNurse){
              this.status = 'Messenger_reports';
              break;
            }
          }
        }
      }

    });
  }

  getInventoryHistory(){
    this.pathologyService.getCompletedInventories(this.startdate, this.enddate).subscribe((data:any[]) => {
      this.completedInventories = data;
    });
  }

  openInventory(inventory){
    this.inventorySigned = false;
    if((this.loginService.userType == 'nurse' && inventory.SigningNurse) ||
      (this.loginService.userType == 'secretary' && inventory.SigningSecretary)) {
      this.inventorySigned = true;
    }
    this.messengerReportID = inventory.AutoIndex;
  }

  openOldInventory(inventory){
    this.pdfMessengerID = inventory.AutoIndex;
  }

  showReport(report:any){
    if(report && report.ReceptionDate)
      this.reportToShow = report.AutoIndex;
  }

  reportView(){
    if(this.reportToShow || this.pdf || this.pdfMessengerID)
      return true;
    return false;
  }

  closeWPDF(pdf){
    if(this.messengerReportID){
      this.lab = '';
      this.labResults = [];
      this.getActiveInventories();
    }

    this.messengerReportID = null;
    this.reportToShow = null;
    this.pdfMessengerID = null;
    this.pdf = pdf;
  }

  reportSelected(){//returns true if nures selected 1 or more checkboxes
    for (const result of this.labResults) {
      if (result.selected) {
        return true;
      } 
    }
    return false;
  }

  goPatient(pid){
    this.patientsService.getPatient(pid, (s) => {
      if (s) this.rt.navigate(["/exams"], { state: { data: this.patientsService.currentPatient } });
    });
  }

  getPathNotes(result){
    //loginService.userType === 'nurse' && status == 'Awaiting_transfer' && lab ? getPathNotes(result):'Open Lab Results'
    if( this.loginService.userType != 'nurse' || this.status != 'Awaiting_transfer' || ! this.lab){
      if(this.status != 'Needs_Analysis' && this.status != 'Needs_Assignment')
        return '';
      return 'Open Lab Results';
    }
    let txt = '';
    let i=1;
    for(let p of result.pathology){
      txt += `${i++}) ${p.Type} ${p.Comments} Barcode:${p.BarCode}` + ' ';
    }
    return txt;
  }

  getNeededSignatures(inventory: any): string {
    const needed = [];
    if (!inventory.SigningNurse) needed.push('nurse');
    if (!inventory.SigningSecretary) needed.push('secretary');
    if (!inventory.LabMessenger) needed.push('messenger');
    if (needed.length === 0) return '';
    return `Needs ${needed.join(' and ')} ${needed.length > 1 ? 'signatures' : 'signature'}`;
  }
}
